<template>
  <v-row class="white no-gutters py-2 px-1 text-center" >
    <v-col md="12" sm="12">
      <h1 class="pl-1 text-light font-size-3 titlesdark--text"><strong>{{ title }}</strong></h1>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>

</style>
